<template>
  <div>
    <div class="mt-2">
      <section-title title="Términos y Condiciones" has-line />
    </div>
    <div class="my-2">
      <validation-provider v-slot="{ errors }" rules="required">
        <span class="data-title d-block mb-2">
          Contenido:
        </span>
        <div v-if="isReadOnly" v-html="model.content"></div>
        <vue-editor
          v-if="!isReadOnly"
          id="content-input"
          v-model="model.content"
        />
        <error
          v-if="errors[0]"
          message="La contenido es requerido."
          variant="no-border"
        />
      </validation-provider>
    </div>
    <div class="my-2">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-text-area
          label="Campo de Aceptar:"
          placeholder="Describe la caja de aceptación de los términos y condiciones"
          v-model="model.acceptField"
          :maxlength="3000"
          :error="errors[0]"
          custom-error-msg="El campo de aceptar es requerido"
          :disabled="isReadOnly"
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import { VueEditor } from 'vue2-editor';
import Error from 'custom-error';

export default {
  name: 'TermsAndConditionsTab',
  components: {
    SectionTitle,
    CustomTextArea,
    CustomInput,
    VueEditor,
    Error,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
